import { Card, Col, Popconfirm, Row, Tabs } from 'antd'
import CustomBreadCrumb from 'components/Common/CustomBreadCrumb'
import Documents from 'components/Common/Documents/DocumentsCont'
import History from 'components/Common/History'
import WarrantyForm from 'components/Main/Warranty/WarrantyForm'
import FooterButtons from 'elements/Buttons/FooterButtons'
import RefreshButton from 'elements/Buttons/RefreshButton'
import CodeIcon from 'elements/CodeIcon'
import IconText from 'elements/IconText'
import Status from 'elements/Status'
import Authentication from 'modules/Authentication'
import { strVal } from 'modules/Utils'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { streamUrl } from 'variables'
import CustomSpin from '../../../../elements/CustomSpin'

const auth = new Authentication()

function AddWarranty(props) {
  const {
    fetching,
    formRef,
    data,
    isNew,
    fetch,
    submitting,
    submit,
    update,
    remove,
    updating,
    removing,
    actions,
    handleActions,
  } = props

  const isConfirmed = data.status === 'Confirmed'

  const Operations = ({ warranty, ...rest }) => {
    const ops = actions
      .filter((a) => a.key !== 'update' && a.key !== 'remove')
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))
    if (ops.length > 0) {
      ops.push(
        <a target={'_blank'} href={`${streamUrl}pdf/${data._id}?access_token=${auth.getAccessToken()}`}>
          <IconText text={'PDF preview'} type={'file-pdf'} />
        </a>
      )
    }

    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
      </div>
    )
  }

  return (
    <CustomSpin spinning={fetching}>
      <Card>
        <Row>
          <CustomBreadCrumb
            items={[
              {
                text: 'Warranty',
                link: '/#/warranty',
              },
              { text: isNew ? 'New Warranty' : data.code },
            ]}
          />
          {isNew && <h2>New data</h2>}

          {!isNew && (
            <Fragment>
              <Col span={17}>
                <h3 style={{ marginTop: '10px' }}>
                  <CodeIcon code={strVal(data, 'code')} title={'Warranty Code'} />
                  <Status value={strVal(data, 'status')} />
                  <Operations style={{ marginTop: '10px' }} warranty={data} status={strVal(data, 'status')} />
                </h3>
              </Col>
              <RefreshButton onClick={fetch} />
            </Fragment>
          )}
        </Row>
      </Card>

      <Card style={{ marginTop: '20px' }}>
        <Tabs defaultActiveKey="form">
          <Tabs.TabPane tab="Details" key="form">
            <WarrantyForm ref={formRef} {...props} />

            <FooterButtons
              visible={true}
              remove={remove}
              removing={removing}
              submit={submit}
              update={update}
              isNew={isNew}
              submitting={submitting || updating}
              title={'Warranty'}
              isEdit={!isConfirmed}
              isRemovable={!isConfirmed}
              isUpdatable={!isConfirmed}
            />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={isNew} tab="Documents" key="files">
            <Documents editable={true} footer={false} category={false} owner={data} />
          </Tabs.TabPane>
          <Tabs.TabPane disabled={isNew} tab="History" key="history">
            <History owner={data} key={data._rev} isArray={true} />
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default AddWarranty
